var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInformationGrey = function SvgInformationGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10,
    r: 10,
    fill: "#C3C3C3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.25 7.444c-.958 0-1.75-.734-1.75-1.713C8.5 4.734 9.292 4 10.25 4c.976 0 1.75.734 1.75 1.731 0 .979-.774 1.713-1.75 1.713m1.474 1.43V15H8.739V8.874z"
  })));
};
export { SvgInformationGrey as ReactComponent };
export default __webpack_public_path__ + "images/information-grey.svg";